import React, { Dispatch, SetStateAction } from "react";
import LeftInfoModal from "../../components/left-info-modal";
import { images } from "../../assets";
import { Error } from "./privileges-dto";

const PrivilegesError = ({
  error,
  setError,
}: {
  error: Error;
  setError: Dispatch<SetStateAction<Error>>;
}): JSX.Element => {
  return (
    <LeftInfoModal
      active={error.showError}
      className="error"
      mainTitle={error.mainTitle}
      mainText={error.mainText}
      buttonText="Cerrar"
      img={images.WarningError}
      close={() => setError({ showError: false, mainTitle: "", mainText: "" })}
      onClickAccept={() => setError({ showError: false, mainTitle: "", mainText: "" })}
      noSecondaryButton
    />
  );
};

export default PrivilegesError;
